import { useRouteError } from 'react-router-dom';

export default function RouteErrorPage() {
  const error: unknown = useRouteError();
  const unavailableModule = error instanceof Error && /dynamically imported module|loading chunk|module script/i.test(error.message);
  return <main className="mx-auto max-w-xl space-y-4 px-6 py-16">
    <h1 className="text-title font-semibold">This page could not be opened</h1>
    <p role="alert">{unavailableModule
      ? 'Part of the application could not be loaded. This can happen after an update or a connection interruption. Reload the page to try again.'
      : 'The page encountered a problem. Reload it to try again, or return to Business records.'}</p>
    <div className="flex gap-4">
      <a className="text-primary underline" href={window.location.href}>Reload page</a>
      <a className="text-primary underline" href={`${(import.meta.env.VITE_ROUTER_BASENAME ?? '/').replace(/\/?$/, '/')}admin/masterdata`}>Business records</a>
    </div>
  </main>;
}
